export const TRANSCRIPT_SPACE = 'TRANSCRIPT_SPACE'
export const TRANSCRIPT_WORD = 'TRANSCRIPT_WORD'
